import { flux } from '@/core/flux.module';
import type { StoredTableOutputV1 } from '@/sdk/model/StoredTableOutputV1';
import type { GridApi } from 'ag-grid-enterprise';
import type { MaterializedTableOutput } from '@/tableDefinitionEditor/tableDefinition.types';

export function setTableId(tableId: string) {
  flux.dispatch(`STORED_TABLE_SET_TABLE_ID`, { tableId });
}

export function setStoredTable(storedTable: StoredTableOutputV1) {
  flux.dispatch(`SET_STORED_TABLE`, { storedTable });
}

export function resetStoredTable() {
  flux.dispatch(`RESET_STORED_TABLE`);
}

export function setIsLoadingStoredTable(isLoadingStoredTable: boolean) {
  flux.dispatch(`STORED_TABLE_SET_IS_LOADING_STORED_TABLE`, { isLoadingStoredTable });
}

export function setAgGridApi(agGridApi: GridApi) {
  flux.dispatch(`SET_STORED_TABLE_AG_GRID_API`, { agGridApi });
}

export function setMaterializedTable(materializedTable: MaterializedTableOutput | undefined) {
  flux.dispatch('SET_STORED_TABLE_MATERIALIZED_TABLE', { materializedTable });
}

export function setStoredTableName(name: string | undefined) {
  flux.dispatch('SET_STORED_TABLE_NAME', { name });
}
